/* eslint-disable no-console -- file defines debug logs */
import { IS_PROD } from 'shared/helpers/env';

export const debugLog: typeof console.log = (...args) => {
  if (!IS_PROD) {
    console.log(...args);
  }
};

/**
 * @public
 */
export const debugWarn: typeof console.log = (...args) => {
  if (!IS_PROD) {
    console.warn(...args);
  }
};

/**
 * @public
 */
export const debugTrace: typeof console.log = (...args) => {
  if (!IS_PROD) {
    console.trace(...args);
  }
};
